import * as jsxRuntime from "/home/jenkins/agent/workspace/Orange-Team/sgmo-build-trademanagement-front-specific/app-trademanagement/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment